import React from "react";
import CNModuleSubtopic from "../CNModuleSubtopic";

const RoutingProtocolsAlgorithms = () => (
  <CNModuleSubtopic
    title="Routing-Link State and Distance Vector Routing Protocols- Implementation-Performance Analysis- Packet Tracer"
    videos={[
      "https://www.youtube.com/embed/rA0p0ouD3aE",
      "https://www.youtube.com/embed/5ZuP5qjbKSI",
      "https://www.youtube.com/embed/eXXM7ukL4_k",
      "https://www.youtube.com/embed/C2_6womzsrk"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "Evaluate the shortest path of all links to A using Dijkstra's Algorithm",
        image: "/CN_5.png"
      },
      {
        text: "Use the Dijkstra's algorithm to solve the shortest path problem for the following graph. Find shortest path from V1 to all other vertices. Draw a table showing the intermediate distance values of all the vertices at each iteration.",
        image: "/CN_6.png"
      },
      {
        text: "The CSE department at Princeton University bought new Sun Fire V210 servers. They decided to run a distance-vector protocol for routing between these servers (even though it is a small network). Apply Bellman Ford Algorithm to construct routing table for node I. Depict all steps. Discuss handling scenario when links between D and E fail.",
        image: "/CN_7.png"
      },
      {
        text: "Apply Bellman Ford Algorithm to construct routing table for node I, assume links between D and E fail. Discuss handling in distance vector scheme.",
        image: "/CN_8.png"
      },
      {
        text: "Apply Link State routing for the network with node 'A' as root. Illustrate Dijkstra's algorithm steps and evaluate shortest path tree and routing table.",
        image: "/CN_9.png"
      },
      {
        text: "Routers 1 to 5 connected, Show count-to-infinity problem if node A fails. Explain solution.",
        image: "/CN_10.png"
      },
      {
        text: "Provide routing tables with knowledge limited to neighbors.",
        image: "/CN_11.png"
      },
      {
        text: "Formulate routing tables using equation D(v)= min(D(v), D(w)+c(w,v)), where D=distance, c=cost, w=source.",
        image: "/CN_12.png"
      },
      {
        text: "Perform Dijkstra algorithm to find shortest paths for nodes 0 and 4.",
        image: "/CN_13.png"
      },
      {
        text: "Distance vector routing in network with 6 routers. Show router 1's tables after 1st and 2nd iterations and final table. How many links are unused and why?",
        image: "/CN_14.png"
      },
      {
        text: "Demonstrate Distance Vector routing algorithm starting from node F, showing steps and shortest paths.",
        image: "/CN_15.png"
      },
      {
        text: "Explain count-to-infinity problem and its solution in distance vector routing. Discuss limitations."
      },
      {
        text: "Use link state routing to find shortest paths from node E. Analyse challenges.",
        image: "/CN_16.png"
      },
      {
        text: "Given a company's network of 6 servers with link weights, calculate shortest paths from S1 using Dijkstra, list paths and times.",
        image: "/CN_17.png"
      },
      {
        text: "Discuss routing in multiple autonomous systems: inter-domain routing (BGP) and intra-domain routing (OSPF/RIP). Explain routing loops and their prevention with methods like split horizon and hold-down timers."
      },
      {
        text: "In the network with nodes A,B,C,D,E and links as described,A is connected to B and C. B is connected to A, C, and D.C is connected to A, B, and E. D is connected to B. E is connected to C.  analyze adding link B-E with cost 4:\ni) Describe LSA flooding and routers' updates.\nii) Calculate new shortest path from D to E."
      }
    ]}
    exampleVideos={[]}
  />
);

export default RoutingProtocolsAlgorithms;

